import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const faqs = [
  { q: "Em que formato recebo o workbook?", a: "Recebes um PDF de 45 páginas, pronto para imprimires em formato A4. Após o pagamento, a hiperligação para descarregares o ficheiro chega-te por email em poucos minutos." },
  { q: "Tenho de o imprimir para fazer os exercícios?", a: "Não és obrigada — mas é fortemente recomendado. Escrever à mão muda a forma como pensas." },
  { q: "Quanto tempo demora a fazer?", a: "Não há um tempo certo. Há quem leve dias, outras pessoas levam meses. O ritmo é teu." },
  { q: "Posso oferecer este workbook a alguém?", a: "Sim, podes. Após a compra, basta encaminhares o email com o PDF." },
  { q: "Tens dúvidas antes de comprar?", a: "Fala diretamente comigo através do e-mail info@anabelareisconsultoria.pt. Prometo responder-te em menos de 24 horas." },
  { q: "O pagamento é seguro?", a: "Sim. O processamento é feito pelo Stripe através de uma ligação totalmente encriptada. Nós nunca temos acesso aos dados do teu cartão." },
];

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 md:py-36 px-6 md:px-12 bg-cream"
    >
      <div className="max-w-[1200px] mx-auto grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <span className="section-num mb-6 inline-flex">10 · Dúvidas</span>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl text-ink leading-[1.05]">
            Dúvidas mais
            <br />
            frequentes
            <br />
            <span className="font-serif-display text-orange normal-case lowercase">antes de comprares.</span>
          </h2>
        </div>
        <div className="md:col-span-8">
          {faqs.map((f, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-30px" }}
              transition={{ duration: 0.25, delay: i * 0.02 }}
              className="border-b border-line first:border-t"
              data-testid={`faq-${i}`}
            >
              <button
                className="w-full flex items-start justify-between gap-6 py-6 text-left group"
                onClick={() => setOpen(open === i ? -1 : i)}
                data-testid={`faq-toggle-${i}`}
              >
                <span className="font-display text-base md:text-xl text-ink group-hover:text-orange transition-colors duration-300 leading-tight">
                  {f.q}
                </span>
                <span
                  className={`text-2xl text-ink-soft transition-transform duration-300 flex-shrink-0 ${
                    open === i ? "rotate-45 text-orange" : ""
                  }`}
                >
                  +
                </span>
              </button>
              <AnimatePresence>
                {open === i && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.2 }}
                    className="overflow-hidden"
                  >
                    <p className="text-ink-soft text-base md:text-lg leading-relaxed max-w-2xl pb-6">
                      {f.a}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
